/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guidevideo_Saved1Inputs */

const vi_guidevideo_saved1 = /** @type {(inputs: Guidevideo_Saved1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đã lưu video hướng dẫn.`)
};

/**

* @param {Guidevideo_Saved1Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
const guidevideo_saved1 = /** @type {((inputs?: Guidevideo_Saved1Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guidevideo_Saved1Inputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_guidevideo_saved1(inputs)
});
export { guidevideo_saved1 as "guideVideo_saved" }